const browserExtensionServices = [
  'chrome.google.com',
  'microsoft.com/edge',
  'mozilla.org/firefox',
]

export const isBrowserExtension = (service) =>
  service && browserExtensionServices.includes(service)

export const buildExternalReferenceFromParams = (params) => {
  return {
    id: params.external_item_id,
    group_id: params.external_group_id,
    account_id: params.external_account_id,
    permalink: params.permalink,
    service: params.service,
    app_name: params.app_name,
  }
}
